/* eslint-disable */
import Colors from '../../Support/Theme/Colors/Colors'

const hourglassFullStyles = ({ theme }) => ({
  avatar: {
    width: '20px',
    height: '20px',
    backgroundColor: Colors.gimblet[500],
  },
  lg: {
    width: '32px',
    height: '32px',
  },
  icon: {
    fontSize: '14px',
  },
  lgIcon: {
    fontSize: '20px',
  },
})

export default hourglassFullStyles
